// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".welcome-banner {\n    background: red;\n    color: white;\n\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n\n    padding: 0 2rem 0 1rem;\n\n    z-index: 1;\n}\n\n.welcome-banner__header{\n    margin-top: 0.25rem;\n}\n", ""]);
// Exports
module.exports = exports;
